import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';
import formatNumber from '../../utils/functions';

export default function OrdersList({ open, onClose, refreshOrder, setOrderDetails }) {
  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    const savedOrders = JSON.parse(localStorage.getItem('orders')) || [];
    setOrders(savedOrders);
    setLoading(false);
  }, [refreshOrder, open]);

  if (!open) return null;

  const loadOrder = (orderId) => {
    const savedOrders = JSON.parse(localStorage.getItem('orders')) || [];
    const selectedOrder = savedOrders.find((order) => order.orderId === orderId);

    if (selectedOrder) {
      setOrderDetails(selectedOrder);
      onClose();
      Swal.fire({
        title: 'Commande chargée',
        text: `La commande ${selectedOrder.orderId} a été chargée dans le panier.`,
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  const filteredOrders = orders.filter((order) =>
    order.orderId.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <DuoModal
      title="Commandes enregistrées"
      onClose={onClose}
      size="lg"
      footer={
        <button type="button" className="duo-btn duo-btn--ghost" onClick={onClose}>
          Fermer
        </button>
      }
    >
      <input
        type="search"
        className="duo-input mb-3"
        placeholder="Rechercher par identifiant..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {loading ? (
        <p className="duo-empty mb-0">Chargement...</p>
      ) : filteredOrders.length === 0 ? (
        <p className="duo-empty mb-0">Aucune commande enregistrée localement.</p>
      ) : (
        <div className="duo-modal-orders-scroll">
          {filteredOrders.map((order) => (
            <div key={order.orderId} className="duo-saved-order-card">
              <span className="duo-badge duo-badge--success">ID: {order.orderId}</span>
              <div className="duo-saved-order-card__row">
                <span className="duo-saved-order-card__label">Client</span>
                <span>{order.selectedCustomer?.label || '—'}</span>
              </div>
              <div className="duo-saved-order-card__row">
                <span className="duo-saved-order-card__label">Total</span>
                <span>{formatNumber(order.total ?? 0)} FCFA</span>
              </div>
              <div className="duo-saved-order-card__row">
                <span className="duo-saved-order-card__label">Date</span>
                <span>{new Date(order.dateCreated).toLocaleDateString('fr-FR')}</span>
              </div>
              <button type="button" className="duo-btn duo-btn--primary duo-btn--block mt-2" onClick={() => loadOrder(order.orderId)}>
                Ouvrir dans le panier
              </button>
            </div>
          ))}
        </div>
      )}
    </DuoModal>
  );
}
